<a class="tab" [routerLink]="routerLink" [queryParams]="queryParams" routerLinkActive="is-active">
	<ng-content></ng-content>
	<span class="tab-border"></span>
</a>
